module.exports = __webpack_public_path__ + "img/鎏金面膜_03.e29549d8.jpg";